import { useEffect, useLayoutEffect } from "react";

/**
 * Use correct effects hooks based on the execution environment.
 * `useLayoutEffect` will be called on the client, `useEffect` will be called on the server
 * @function useIsoLayoutEffect
 */
export const useIsoLayoutEffect =
	typeof window !== "undefined" ? useLayoutEffect : useEffect;